import React from 'react';
import Header from '../Header/Header';

const NotFound = () => {
	return (
		<div>
			<Header />
			<h1 className="text-center">Not Foound!!! 404 ERROR</h1>
		</div>
	);
};

export default NotFound;
